(function() {
    'use strict';
    const trackingUtils = require('../modules/utils/tracking.utils');
    const tagManagement = require('../modules/utils/tag_management.utils');
    const {getRememberMeCookieField} = require('../modules/utils/sso.utils');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');
    const loginExpiredFactory = require('components/user_area/login_expired_manager/js/main');

    Odigeo.Router.handlers.loginexpired = function() {
        const LOGIN_EXPIRED = 'loginexpired';
        const $page = $('#page');

        $page.removeClass().addClass(LOGIN_EXPIRED);

        const widgetLoader = createWidgetLoader({
            loginExpired: ['login-expired-manager', loginExpiredFactory],
        });

        Odigeo.Router.eventController = $.extend(Odigeo.Router.eventController,
            Odigeo.Router.handlers.globalEventController, Odigeo.Router.handlers.userEventController);
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController, {
            globalEvents: {
                'login-expired-manager:submitUserRequest': 'onUserManagerRequest',
                'login-expired-login-form:submitUserRequest': 'onUserManagerRequest',
                'global:userLogged': 'onLoginExpiredLoginOK',
                'users-manager:loginWithError': 'onLoginExpiredLoginError',
                'users-manager:loginError': 'onLoginExpiredLoginError',
                'users-manager:logOutOk': 'onGoToHomePage',
                'users-manager:loginWithFacebookOk': 'onSocialLoginOk',
                'users-manager:loginWithGoogleOk': 'onSocialLoginOk',
                // todo: meanwhile backend is adapted, when user is logged in session but not in user service then redirect to home page
                'users-manager:isLoggedInOk': 'onGoToHomePage',
                /** Recaptcha Widget */
                'recaptcha:loaded': 'onRecaptchaLoaded',
            },

            eventHandlers: {
                onLoginExpiredLoginOK: function() {
                    const isLoginWithMail = getRememberMeCookieField('loginType') === 'mail';
                    trackingUtils.trackEventWithCategory('signin_successful_message', 'sign_in', 'sso_expired');
                    if (isLoginWithMail) {
                        _navigateAfterLoginOkEvent();
                    }
                },
                onLoginExpiredLoginError: function(data) {
                    widgetLoader.get('loginExpired').execute('showLoginError', data);
                },
                onUserManagerRequest: function(data, isControllerAction) {
                    const method = isControllerAction ? data.action : 'submitUserRequest';
                    const requestData = isControllerAction ? data.data : data;
                    Odigeo.requireWidget('users-manager', 'usersmanager', function(usersmanager) {
                        usersmanager.execute(method, requestData);
                    });
                },
                onGoToHomePage: function() {
                    Odigeo.Utils.goToApplicationHome();
                },
                onSocialLoginOk: function() {
                    _navigateAfterLoginOkEvent();
                },
                onRecaptchaLoaded: function() {
                    widgetLoader.get('loginExpired').execute('renderCaptcha');
                },
            },
        });
        Odigeo.Router.eventController.execute();
        widgetLoader.get('loginExpired');

        const _navigateAfterLoginOkEvent = function() {
            const lastRouteChange = Odigeo.Utils.parseJson(Odigeo.Session.get('lastRouteChange'));
            const pageToReturnTo = Odigeo._.get(lastRouteChange, 'from.name', 'home');
            if (pageToReturnTo === 'home') {
                Odigeo.Utils.goToApplicationHome();
            } else {
                Odigeo.Router.navigate(pageToReturnTo);
            }
        };

        // Analytics: virtual page tracking
        trackingUtils.trackPage(LOGIN_EXPIRED, {
            funnel: false,
        });
        tagManagement.updateDatalayer();
    };
}());
